<!-- 产品信息管理 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="w200 mr-24 mb-24" type="text" v-model="storePrams.name" placeholder="请输入商品名称"></Input>
            <Select class="w200 mr-24 mb-24" v-model="storePrams.type_id" clearable filterable placeholder="所有分类">
                <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.type_name }}</Option>
            </Select>
            <Button class="theme-bg mb-24" icon="ios-search" type="warning" @click="goSearch">确认搜索</Button>
        </div>
        <div class="content">
            <div>
                <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="goDrawer">新增产品</Button>
                <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection">
                    <template slot-scope="{ row }" slot="show_product_imgs">
                        <div class="flex-c">
                            <img class="table_picture" v-if="row.show_product_imgs" :src="row.show_product_imgs[0]">
                            <img class="table_picture" v-else src="../../assets/example1.png">
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="name">
                        <div>{{row.name}} ID：{{row.id}} 规格：{{row.specs}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="price">
                        <div v-if="row.price">￥：{{row.price}}</div>
                        <div v-else></div>
                    </template>
                    <template slot-scope="{ row }" slot="type">
                        <div>{{row.type ? row.type.type_name : ''}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="template_type">
                        <div class="flex-c" @click="goModal(1, row)">
                            <template v-if="row.template_type == 0">
                                <Button v-if="row.old_template" type="success" label="small">{{row.old_template.title}}</Button>
                                <Button v-else label="small">选择模板</Button>
                            </template>
                            <template v-else-if="row.template_type == 1">
                                <Button v-if="row.product_template" type="success" label="small">{{row.product_template.title}}</Button>
                                <Button v-else label="small">选择模板</Button>
                            </template>
                            <template v-else-if="row.template_type == 2">
                                <Button v-if="row.diy_template" type="success" label="small">{{row.diy_template.title}}</Button>
                                <Button v-else label="small">选择模板</Button>
                            </template>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="show_report_imgs">
                        <div class="flex-c" @click="goReport(row)">
                            <Button v-if="row.show_report_imgs.length" type="success" ghost label="small">已添加（{{row.show_report_imgs.length}}）</Button>
                            <Button v-else label="small">未添加</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="product_pic_count">
                        <div class="flex-c" @click="goPic(row)">
                            <Button v-if="row.product_pic_count" type="success" ghost label="small">已添加（{{row.product_pic_count}}）</Button>
                            <Button v-else label="small">未添加</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="attribute_content">
                        <div class="flex-c" @click="goAttribute(row)">
                            <Button v-if="row.attribute_content.length" type="success" ghost label="small">已添加（{{row.attribute_content.length}}）</Button>
                            <Button v-else label="small">未添加</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="goDrawer(row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox class="checkbox-ml" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                    <span class="mr-24 ml-24">已经选择{{delData.length}}个</span>
                    <Button type="error" ghost label="large" @click="goDel(0)">删除</Button>
                </div>
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Drawer v-model="drawers" :title="drawerTitle" width="1000">
            <Form :model="formData" label-position="right" :label-width="130">
                <FormItem label="产品名称：">
                    <Input class="w200" type="text" v-model="formData.product_name" placeholder="填写产品名称"></Input>
                </FormItem>
                <FormItem label="产品规格：">
                    <Input class="w200" type="text" v-model="formData.specs" placeholder="填写产品规格"></Input>
                </FormItem>
                <FormItem label="产品图片：">
                    <div>
                        <div class="form_upload mb-24" @click="openModal(0, 1)">
                            <Icon type="ios-add" size="40" color="#AEAEB3"/>
                        </div>
                        <draggable
                            class="dragg_div"
                            v-model="itemData.show_product_imgs"
                            chosen-class="chosen"
                            force-fallback="true"
                            group="people"
                            animation="500"
                            :handle="'.dragg'"
                            @start="onStart"
                            @end="onEnd"
                            >
                                <div v-for="(item, index) in itemData.show_product_imgs" :key="index">
                                    <div class="form_upload mr-24 mb-24 position_relative dragg">
                                        <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click="delImg(1, index)"/>
                                        <img class="width_height_100" :src="item">
                                    </div>
                                </div>
                        </draggable>
                    </div>
                </FormItem>
                <FormItem label="产品简介：">
                    <Input class="width_800" type="textarea" v-model="formData.content" :autosize="{minRows: 3}" placeholder="输入产品简介"></Input>
                </FormItem>
                <FormItem label="建议零售价：">
                    <Input class="w200" type="number" v-model="formData.price" prefix="logo-yen" placeholder="填写产品价格"></Input>
                </FormItem>
                <FormItem label="产品分类：">
                    <Select class="w200" v-model="formData.type_id" clearable filterable placeholder="请选择产品分类">
                        <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.type_name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="使用模板：">
                    <div class="form_div">
                        <Button @click="goModal(2, formData)">
                            <span v-if="formData.template_id">{{itemData.template_title ? itemData.template_title : "选择模板"}}</span>
                            <span v-else>选择模板</span>
                        </Button>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content">
                                <p>添加模板说明：</p>
                                <p>1、请先在模板和链接栏目中，安装模板,然后进行相关配置。</p>
                                <p>2、如果模板标明了产品类型(如农药溯源模板)，则代表该模板是专用模板，需配合产品及产品关联属性使用。</p>
                                <p>3、如果未标明产品类型，则为通用型模板，可应用于任何产品上。</p>
                            </div>
                        </Tooltip>
                    </div>
                </FormItem>
                <div class="mb-24 form_title">查询结果提示</div>
                <FormItem label="首次查询提示：">
                    <editor class="width_800" :edtor-con="formData.first_query" :index="1" @getContent="getEnContent1" @getContentchange="getEnContentchange1"/>
                </FormItem>
                <FormItem label="非首次查询提示：">
                    <editor class="width_800" :edtor-con="formData.not_first_query" :index="2" @getContent="getEnContent2" @getContentchange="getEnContentchange2"/>
                </FormItem>
                <FormItem label="超额查询提示：">
                    <editor class="width_800" :edtor-con="formData.excess_query" :index="3" @getContent="getEnContent3" @getContentchange="getEnContentchange3"/>
                </FormItem>
                <FormItem>
                    <div class="ta-r">
                        <Button @click="cancelDrawer">取消</Button>
                        <Button class="theme-bg ml-24" type="warning" @click="submitDrawer">确认</Button>
                    </div>
                </FormItem>
            </Form>
        </Drawer>
        <!-- 质检报告 -->
        <Modal v-model="reportModal" title="质检报告" width="500" :mask-closable="false">
            <div>
                <Form :model="reportData" label-position="right" :label-width="100">
                    <FormItem label="质检报告：">
                        <Input type="text" v-model="reportData.report_name" placeholder="请输入质检报告名称"></Input>
                        <div class="mt-24">
                            <div class="form_upload mb-24" @click="openModal(0, 2)">
                                <Icon type="ios-add" size="40" color="#AEAEB3"/>
                            </div>
                            <draggable
                                class="dragg_div"
                                v-model="itemData.show_report_imgs"
                                chosen-class="chosen"
                                force-fallback="true"
                                group="people"
                                animation="500"
                                :handle="'.dragg'"
                                @start="onStart"
                                @end="onEnd"
                                >
                                    <div v-for="(item, index) in itemData.show_report_imgs" :key="index">
                                        <div class="form_upload mr-24 mb-24 position_relative dragg">
                                            <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click="delImg(2, index)"/>
                                            <img class="width_height_100" :src="item">
                                        </div>
                                    </div>
                            </draggable>
                        </div>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelReportModal">取消</Button>
                <Button class="theme-bg" type="warning" @click="submitReportModal">确定</Button>
            </div>
        </Modal>
        <!-- 产品样册 -->
        <Modal v-model="picModal" title="产品样册" width="60" :mask-closable="false">
            <div>
                <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="goAddSample">添加产品样册</Button>
                <Table :columns="columnsPic" :data="dataPic" border>
                    <template slot-scope="{ row }" slot="show_cover">
                        <div class="flex-c">
                            <img class="table_picture" :src="row.show_cover">
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="goAddSample(row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(2, row)">删除</Button>
                        </div>
                    </template>
                </Table>
                <div class="page_div">
                    <Page :current="pagePic.page" :page-size="pagePic.limit" :total="totalPic" show-elevator show-total @on-change="pageChangePic"/>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 产品属性 -->
        <Modal v-model="attributeModal" title="产品属性" width="500" :mask-closable="false">
            <div>
                <Form :model="attributeData" label-position="right" :label-width="100">
                    <FormItem label="产品属性：">
                        <Select v-model="attributeData.attribute_id" clearable filterable placeholder="选择已有产品属性或者直接填写" @on-change="changeAttribute">
                            <Option v-for="item in attributeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                        <div v-for="(item, index) in attributeData.attribute_content" :key="index">
                            <div class="flex-sb mt-12 position_relative width_100">
                                <Input class="width_30" type="text" v-model="item.content_id" placeholder="产品属性名称"></Input>
                                <Input class="width_60" type="text" v-model="item.val" placeholder="请输入属性内容"></Input>
                                <Icon class="cursor-p" v-if="attributeData.attribute_content.length > 1" type="ios-close-circle-outline" color="#FF4838" size="24" @click="delAttributeContent(index)"/>
                            </div>
                        </div>
                        <Button class="theme-bg mt-24" icon="md-add-circle" type="warning" @click="addAttributeContent">添加产品属性</Button>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelAttributeModal">取消</Button>
                <Button class="theme-bg" type="warning" @click="submitAttributeModal">确定</Button>
            </div>
        </Modal>
        <!-- 新增产品样册 -->
        <Modal v-model="sampleModal" title="新增产品样册" width="500" :mask-closable="false">
            <div>
                <Form :model="formSample" label-position="right" :label-width="100">
                    <FormItem label="样册名称：">
                        <Input type="text" v-model="formSample.title" placeholder="请输入产品样册名称"></Input>
                    </FormItem>
                    <FormItem label="封面图：">
                        <div class="form_upload" @click="openModal(1)">
                            <img class="width_height_100" v-if="itemData.show_cover" :src="itemData.show_cover">
                            <Icon v-else type="ios-add" size="44" color="#AEAEB3"/>
                        </div>
                    </FormItem>
                    <FormItem label="图片集：">
                        <div class="form_upload mb-24" @click="openModal(0, 3)">
                            <Icon type="ios-add" size="40" color="#AEAEB3"/>
                        </div>
                        <draggable
                            class="dragg_div"
                            v-model="itemData.show_imgs"
                            chosen-class="chosen"
                            force-fallback="true"
                            group="people"
                            animation="500"
                            :handle="'.dragg'"
                            @start="onStart"
                            @end="onEnd"
                            >
                                <div v-for="(item, index) in itemData.show_imgs" :key="index">
                                    <div class="form_upload position_relative mr-24 mb-24 dragg">
                                        <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click="delImg(3, index)"/>
                                        <img class="width_height_100" :src="item">
                                    </div>
                                </div>
                        </draggable>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelSampleModal">取消</Button>
                <Button class="theme-bg" type="warning" @click="submitSampleModal">确定</Button>
            </div>
        </Modal>
        <!-- 选择模板 -->
        <Modal v-model="modals" :title="modalTitle" :width="modalWidth" :mask-closable="false">
            <div>
                <template v-if="modalID == 2 || modalID == 1">
                    <Menu mode="horizontal" :active-name="formData.template_type" @on-select="selectTemplate">
                        <MenuItem name="1">产品模板</MenuItem>
                        <MenuItem name="2">DIY模版</MenuItem>
                    </Menu>
                    <Table class="mt-24" :columns="columnsTemplate" :data="dataTemplate" border>
                        <template slot-scope="{ index }" slot="id">
                            <div>{{ index + 1 }}</div>
                        </template>
                        <template slot-scope="{ row }" slot="operate">
                            <div class="flex-sa">
                                <div class="width_54">
                                    <div class="t-color" v-if="formData.template_id == row.id">使用中</div>
                                    <Button v-else type="warning" ghost label="small" @click="changeUsing(row)">使用</Button>
                                </div>
                            </div>
                        </template>
                    </Table>
                    <div class="page_div">
                        <Page :current="storeTemplate.page" :page-size="storeTemplate.limit" :total="totalTemplate" show-elevator show-total @on-change="pageChangeTemplate"/>
                    </div>
                </template>
            </div>
            <div slot="footer"></div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import { 
    product_list, 
    product_save, 
    product_info, 
    template_result_template, 
    template_diy_list, 
    product_change_template, 
    product_delete, 
    product_samplebook_list, 
    product_samplebook_save, 
    product_samplebook_del, 
    product_reports, 
    product_add_attribute,
    product_attribute_content_list,
} from '@/api/index';
import { 
    product_type_select, 
    product_attribute_select,
} from '@/api/select';
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
import draggable from "vuedraggable";
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
import VueQr from 'vue-qr'
import editor from "@/components/editor/editor.vue";
export default {
    components: { draggable, pictureLibrary, VueQr, editor},
    data() {
        return {
            srctype: "",
            imgtype: 1,
            switch_modal: false,
            imgConfig: config.apiUrl + '/',
            uploadImg: config.apiUrl + "/adminapi/file_upload",
            headers: { "hlzw-suyuan-token": getCookies("pcToken") },
            storePrams: {
                page: 1,
                limit: 10,
                name: "",
                type_id: -1,
            },
            total: 0,
            columnsTable: [
                { type: 'selection', width: 60, align: 'center' },
                { title: "产品图片", slot: "show_product_imgs", align: "center" },
                { title: "名称及规格", slot: "name", align: "center" },
                { title: "建议零售价", slot: "price", align: "center" },
                { title: "所属分类", slot: "type", align: "center" },
                { title: "使用模板", slot: "template_type", align: "center" },
                { title: "质检报告", slot: "show_report_imgs", align: "center" },
                { title: "产品样册", slot: "product_pic_count", align: "center" },
                { title: "产品属性", slot: "attribute_content", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTable: [],
            reportModal: false,
            picModal: false,
            attributeModal: false,
            sampleModal: false,
            modals: false,
            modalTitle: "",
            modalWidth: "",
            modalID: "",
            typeList: [],
            drawers: false,
            drawerTitle: "",
            infoId: "",
            formData: {
                product_name: "",
                specs: "",
                content: "",
                price: "",
                type_id: "",
                template_id: "",
                first_query: "",
                not_first_query: "",
                excess_query: "",
                product_imgs: "",
                id: "",
                template_type: "1",
            },
            storeTemplate: {
                page: 1,
                limit: 10,
                industry_id: -1,
            },
            totalTemplate: 0,
            columnsTemplate: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "ID", key: "id", align: "center" },
                { title: "模板名称", key: "title", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataTemplate: [],
            itemData: { 
                template_title: "",
                product_imgs: [],
                show_product_imgs: [],
                report_imgs: [],
                show_report_imgs: [],
                imgs: [],
                show_imgs: [],
                useValue: false,
                previewImg: "",
                show_cover: '',
            },
            formItem: {
                attribute_id: "",
            },
            attributeList: [],
            pagePic: {
                page: 1,
                limit: 10,
                product_id: "",
            },
            totalPic: 0,
            columnsPic: [
                { title: "样册名称", key: "title", align: "center" },
                { title: "封面图", slot: "show_cover", align: "center" },
                { title: "添加时间", key: "created_at", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "330px" },
            ],
            dataPic: [],
            formSample: {
                id: "",
                title: "",
                cover: "",
                imgs: "",
                product_id: "",
            },
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            templateID: "",
            attributeData: {
                id: "",
                attribute_id: "",
                attribute_content: [],
            },
            reportData: {
                id: "",
                report_name: "",
                report_imgs: "",
            },
            imgview_icon: "",
            imgview: [],
        };
    },
    mounted() {
        this.getList();
        this.getTypeList();
        // 产品属性下拉
        this.getAttributeSelect();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 0 && this.srctype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.itemData.show_product_imgs.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.itemData.product_imgs.push(param2[i]);
                }
                this.$Message.destroy();
            }else if (this.imgtype == 0 && this.srctype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.itemData.show_report_imgs.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.itemData.report_imgs.push(param2[i]);
                }
                this.$Message.destroy();
            }else if (this.imgtype == 0 && this.srctype == 3) {
                for (var i = 0; i < param1.length; i++) {
                    this.itemData.show_imgs.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.itemData.imgs.push(param2[i]);
                }
                this.$Message.destroy();
            }else if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.itemData.show_cover = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formSample.cover = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e, index) {
            this.imgtype = e;
            this.srctype = index;
            this.switch_modal = true;
        },
        // 产品样册列表
        geSampleBookList(){
            product_samplebook_list(this.pagePic).then((res) => {
                this.dataPic = res.data.data;
                this.totalPic = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getAttributeSelect(){
            product_attribute_select().then((res) => {
                this.attributeList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 移动时
        onStart(e) {
            this.drag = true;
            console.log("触发移动", e);
        },
        // 移动结束
        onEnd(e) {
            this.drag = false;
            console.log("移动结束", e);
        },
        getList() {
            product_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 获取产品分类下拉
        getTypeList(){
            product_type_select().then((res) => {
                this.typeList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        addAttributeContent(){
            this.attributeData.attribute_content.push({content_id: "", val: ""});
        },
        delAttributeContent(index){
            this.attributeData.attribute_content.splice(index, 1);
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageChangeTemplate(index) {
            this.storeTemplate.page = index;
            if(this.formData.template_type == 1){
                this.getTemplateList();
            }else if(this.formData.template_type == 2){
                this.getDiyList();
            }
        },
        pageChangePic(index) {
            this.pagePic.page = index;
            this.getSampleList();
        },
        // 详情
        getInfo(){
            product_info({id: this.infoId}).then((res) => {
                this.formData.id = res.data.id;
                this.formData.product_name = res.data.product_name;
                this.formData.specs = res.data.specs;
                this.formData.content = res.data.content;
                this.formData.price = res.data.price;
                this.formData.type_id = res.data.type_id;
                this.formData.template_id = res.data.template_id;
                this.formData.first_query = res.data.first_query;
                this.formData.not_first_query = res.data.not_first_query;
                this.formData.excess_query = res.data.excess_query;
                this.formData.product_imgs = res.data.product_imgs;
                this.formData.template_type = res.data.template_type + "";
                if(res.data.template_type == 0){
                    this.formData.template_type = "1";
                }
                this.itemData.template_title = res.data.template.title;
                var product_imgs = res.data.product_imgs;
                this.itemData.product_imgs = product_imgs.split(',');
                this.itemData.show_product_imgs = res.data.show_product_imgs;
                if(res.data.report_imgs){
                    var report_imgs = res.data.report_imgs;
                    this.itemData.report_imgs = report_imgs.split(',');
                }
                this.itemData.show_report_imgs = res.data.show_report_imgs;
                this.reportData.report_name = res.data.report_name;
                this.reportData.report_imgs = res.data.report_imgs;
                this.attributeData.attribute_id = res.data.attribute_id;
                if(res.data.attribute_content){
                    this.attributeData.attribute_content = res.data.attribute_content;
                }else {
                    this.attributeData.attribute_content = [];
                }
                if(this.modalID == 2 || this.modalID == 1){
                    if(this.formData.template_type == 1){
                        this.getTemplateList();
                    }else if(this.formData.template_type == 2){
                        this.getDiyList();
                    }
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 模板列表
        getTemplateList(){
            template_result_template(this.storeTemplate).then((res) => {
                this.dataTemplate = res.data.data;
                this.totalTemplate = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getDiyList(){
            template_diy_list(this.storeTemplate).then((res) => {
                this.dataTemplate = res.data.data;
                this.totalTemplate = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goDrawer(row){
            this.drawers = true;
            this.$nextTick(() => {
                if(row.id){
                    this.drawerTitle = "编辑产品";
                    // 详情
                    this.infoId = row.id;
                    this.getInfo();
                }else{
                    this.drawerTitle = "新增产品";
                    this.infoId = "";
                    this.formData.id = "";
                    this.formData.product_name = "";
                    this.formData.specs = "";
                    this.formData.content = "";
                    this.formData.price = "";
                    this.formData.type_id = "";
                    this.formData.template_id = "";
                    this.formData.product_imgs = "";
                    this.itemData.template_title = "";
                    this.itemData.product_imgs = [];
                    this.itemData.show_product_imgs = [];
                    this.formData.template_type = "1";
                    this.formData.first_query = "<h3><span style=\"color: rgb(0, 138, 0);\">本次为首次查询验证，</span></h3><p>防伪编码：{#q}，</p><p>您查询的是正品，感谢您选择我们的产品</p>";
                    this.formData.not_first_query = "<h3><span style=\"color: rgb(0, 102, 204);\">多次查询，请确保是您本人查询，</span></h3><p>防伪编码：{#q}，</p><p>您查询的是本公司正品。本次为第{#s}次查询，</p><p>首次查询时间：{#t}</p>";
                    this.formData.excess_query = "<h3><span style=\"color: rgb(230, 0, 0);\">该码查询次数过多，已被系统锁定，</span></h3><p>防伪编码：{#q}</p>";
                    this.getTemplateList();
                }
            });
        },
        // selection
        changeSelection(e){
            this.delData = e;
            if(this.dataTable.length === e.length){
                this.del_value = true;
            }else{
                this.del_value = false;
            }
        },
        handleSelectAll(e){
            if(e == true){
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            }else{
                this.$refs.selection.selectAll(false);
            }
        },
        goSearch() {
            this.getList();
        },
        goReport(row){
            this.infoId = row.id;
            this.getInfo();
            this.reportData.id = row.id;
            setTimeout(() => {
                this.reportModal = true;
            }, 500);
        },
        goPic(row){
            this.pagePic.product_id = row.id;
            this.geSampleBookList();
            this.formSample.product_id = row.id;
            setTimeout(() => {
                this.picModal = true;
            }, 500);
        },
        goAttribute(row){
            this.infoId = row.id;
            this.getInfo();
            this.attributeData.id = row.id;
            setTimeout(() => {
                this.attributeModal = true;
            }, 500);
        },
        changeAttribute(e){
            if(e){
                product_attribute_content_list({id: e}).then((res) => {
                    var data = res.data;
                    data = res.data.map(item => (
                        {content_id: item.attribute_name, val: item.attribute_tips}
                    ))
                    this.attributeData.attribute_content = data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
            }
        },
        goAddSample(row){
            if(row.id){
                this.formSample.id = row.id;
                this.formSample.title = row.title;
                this.formSample.cover = row.cover;
                this.itemData.show_cover = row.show_cover;
                this.formSample.imgs = row.imgs;
                this.itemData.show_imgs = row.show_imgs;
                var imgs = row.imgs;
                this.itemData.imgs = imgs.split(',');
            }else{
                this.formSample.id = "";
                this.formSample.title = "";
                this.formSample.cover = "";
                this.itemData.show_cover = '';
                this.formSample.imgs = "";
                this.itemData.show_imgs = [];
                this.itemData.imgs = [];
            }
            setTimeout(() => {
                this.sampleModal = true;
            }, 200);
        },
        goModal(index, row) {
            this.modalID = index;
            if(index == 1){
                this.modalTitle = ' ';
                this.modalWidth = 60;
                this.infoId = row.id;
                this.getInfo();
                this.formData.id = row.id;
            }else if(index == 2){
                this.modalTitle = ' ';
                this.modalWidth = 60;
                if(row.id){
                    this.infoId = row.id;
                    this.getInfo();
                    this.formData.id = row.id;
                }
            }
            setTimeout(() => {
                this.modals = true;
            }, 750);
        },
        cancelReportModal(){
            this.reportModal = false;
        },
        submitReportModal(){
            this.reportData.report_imgs = this.itemData.report_imgs.join(',');
            product_reports(this.reportData).then( res => {
                this.getList();
                this.reportModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        cancelAttributeModal(){
            this.attributeModal = false;
        },
        submitAttributeModal(){
            product_add_attribute(this.attributeData).then( res => {
                this.getList();
                this.attributeModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        cancelSampleModal(){
            this.sampleModal = false;
        },
        submitSampleModal(){
            this.formSample.imgs = this.itemData.imgs.join(',');
            product_samplebook_save(this.formSample).then( res => {
                this.geSampleBookList();
                this.getList();
                this.sampleModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        cancelDrawer(){
            this.drawers = false;
        },
        // 确定
        submitDrawer(){
            this.formData.product_imgs = this.itemData.product_imgs.join(',');
            product_save(this.formData).then( res => {
                this.getList();
                this.drawers = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        changeUsing(row) {
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变使用状态吗？",
                onOk: () => {
                    that.formData.template_id = row.id;
                    that.itemData.template_title = row.title;
                    if(this.modalID == 1){
                        const data = {
                            product_id: this.formData.id,
                            template_id: this.formData.template_id,
                            template_type: this.formData.template_type,
                        }
                        product_change_template(data).then( res => {
                            that.getList();
                            that.modals = false;
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        }) 
                    }
                    else if(this.modalID == 2){
                        this.modals = false;
                        this.drawers = true;
                    }
                },
                onCancel: () => {
                },
            });
        },
        goDel(index, row){
            if(index == 0 && this.delData.length == 0){
                this.$Message.error('请选择');
                return
            }
            let that = this;
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    if(index == 0){
                        var del_id = [];
                        this.delData.forEach(item => {
                            del_id.push(item.id)
                        });
                        this.del_id = del_id.join(',');
                        product_delete({ id: this.del_id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 1){
                        product_delete({ id:row.id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 2){
                        product_samplebook_del({ id:row.id }).then(res=>{
                            that.geSampleBookList();
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }
                },
                onCancel: () => {
                }
            }); 
        },
        selectTemplate(name) {
            this.formData.template_type = name;
            if(name == 1){
                this.getTemplateList();
            }else if(name == 2){
                this.getDiyList();
            }
        },
        delImg(e, index){
            if(e == 1){
                this.itemData.product_imgs.splice(index, 1);
                this.itemData.show_product_imgs.splice(index, 1);
            }else if(e == 2){
                this.itemData.report_imgs.splice(index, 1);
                this.itemData.show_report_imgs.splice(index, 1);
            }else if(e == 3){
                this.itemData.show_imgs.splice(index, 1);
                this.itemData.imgs.splice(index, 1);
            }
        },
        //富文本
        getEnContentchange1(detailData) {
            this.formData.first_query = detailData.editorData;
        },
        getEnContent1(detailData) {
            this.formData.first_query = detailData.editorData;
        },
        getEnContentchange2(detailData) {
            this.formData.not_first_query = detailData.editorData;
        },
        getEnContent2(detailData) {
            this.formData.not_first_query = detailData.editorData;
        },
        getEnContentchange3(detailData) {
            this.formData.excess_query = detailData.editorData;
        },
        getEnContent3(detailData) {
            this.formData.excess_query = detailData.editorData;
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.page_div {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.table_picture {
    margin: 12px 0;
    width: 60px;
    height: 60px;
}
.form_upload {
    width: 70px;
    height: 70px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px dashed #9FA5BB;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
/* .chosen {
    border: dashed 1px #FF761D !important;
} */
::v-deep .ivu-menu.ivu-menu-light.ivu-menu-horizontal{
    display: flex;
    align-items: center;
    justify-content: space-around;
}
::v-deep .ivu-menu-item {
    font-size: 16px;
}
::v-deep .ivu-menu-item:hover {
    font-size: 16px;
    color: #FF761D !important;
    border-bottom: 2px solid #FF761D !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    color: #FF761D;
    font-size: 16px;
    border-bottom: 2px solid #FF761D !important;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.dragg_div {
    display: flex;
    flex-wrap: wrap;
}
.position_relative {
    position: relative;
}
.form_icon {
    position: absolute;
    top: -10px;
    right: -10px;
}
.width_800 {
    width: 800px;
}
.form_div {
    display: flex;
    align-items: center;
}
.form_title {
    color: #484E66;
    font-weight: bold;
}
.width_100 {
    width: 100%;
}
.width_30 {
    width: 30%;
}
.width_60 {
    width: 60%;
}
.width_height_100 {
    width: 100%;
    height: 100%;
}
.width_54 {
    width: 54px;
}
</style>